import * as Cases from '../slices/casesSlice';
import * as UI from '../slices/uiSlice';
import { useAppDispatch, useAppSelector } from '../slices/index';
import { useNavigate } from 'react-router-dom';
import { AnyAction } from '@reduxjs/toolkit';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSync } from '@fortawesome/free-solid-svg-icons';
import icon_mainhub from '../assets/MainHub_White.svg';
import icon_wishlist from '../assets/Wishlist_White.svg';
import icon_team from '../assets/The_Team_White.svg';

const CaseListExpand = (item: Cases.caseListState) => {
	const cases = useAppSelector(state => state.cases);
	const user = useAppSelector(state => state.user);
	const dispatch = useAppDispatch();
	const navigate = useNavigate();

	const actionOnRow = (item: Cases.caseListState) => {
		dispatch(Cases.selectCase(item.caseno));
	}

	const openCase = (item: Cases.caseListState) => {
		if (cases.case.caseno === item.caseno) {
			navigate('/case');
			return;
		}
		const setcaseno = () => new Promise((resolve) => resolve(dispatch((Cases.setCaseNo(item)) as unknown as AnyAction)));
		dispatch(Cases.setOpeningCase(true));
		setcaseno().then(() => dispatch(Cases.getCase(({ caseno: item.caseno, type: item.casetype, id: user.id, token: user.token })) as unknown as AnyAction).then((result: any) => {
			let action;
			try {
				action = JSON.parse(result.payload as string);
			} catch (e) {
				dispatch(UI.setError({ visible: true, message: result.payload }));
				return;
			}
			if (action.status === 'OK') {
				navigate('/case');
				return;
			} else {
				dispatch(UI.setError({ visible: true, message: result.payload }));
				return;
			}
		}));
	}

	const openActions = (item: Cases.caseListState) => {
		if (cases.case.caseno === item.caseno) {
			navigate('/actions');
			return;
		}
		const setcaseno = () => new Promise((resolve) => resolve(dispatch((Cases.setCaseNo(item)) as unknown as AnyAction)));
		dispatch(Cases.setOpeningActions(true));
		setcaseno().then(() => dispatch(Cases.getCase(({ caseno: item.caseno, type: item.casetype, id: user.id, token: user.token })) as unknown as AnyAction).then((result: any) => {
			let action;
			try {
				action = JSON.parse(result.payload as string);
			} catch (e) {
				dispatch(UI.setError({ visible: true, message: result.payload }));
				return;
			}
			if (action.status === 'OK') {
				navigate('/actions');
				return;
			} else {
				dispatch(UI.setError({ visible: true, message: result.payload }));
				return;
			}
		}));
	}

	const openHistory = (item: Cases.caseListState) => {
		if (cases.case.caseno === item.caseno) {
			navigate('/historylist');
			return;
		}
		const setcaseno = () => new Promise((resolve) => resolve(dispatch((Cases.setCaseNo(item)) as unknown as AnyAction)));
		dispatch(Cases.setOpeningHistory(true));
		setcaseno().then(() => dispatch(Cases.getCase(({ caseno: item.caseno, type: item.casetype, id: user.id, token: user.token })) as unknown as AnyAction).then((result: any) => {
			let action;
			try {
				action = JSON.parse(result.payload as string);
			} catch (e) {
				dispatch(UI.setError({ visible: true, message: result.payload }));
				return;
			}
			if (action.status === 'OK') {
				navigate('/historylist');
				return;
			} else {
				dispatch(UI.setError({ visible: true, message: result.payload }));
				return;
			}
		}));
	}

	const openTeam = (item: Cases.caseListState) => {
		if (cases.case.caseno === item.caseno) {
			navigate('/team');
			return;
		}
		const setcaseno = () => new Promise((resolve) => resolve(dispatch((Cases.setCaseNo(item)) as unknown as AnyAction)));
		dispatch(Cases.setOpeningTeam(true));
		setcaseno().then(() => dispatch(Cases.getCase(({ caseno: item.caseno, type: item.casetype, id: user.id, token: user.token })) as unknown as AnyAction).then((result: any) => {
			let action;
			try {
				action = JSON.parse(result.payload as string);
			} catch (e) {
				dispatch(UI.setError({ visible: true, message: result.payload }));
				return;
			}
			if (action.status === 'OK') {
				navigate('/team');
				return;
			} else {
				dispatch(UI.setError({ visible: true, message: result.payload }));
				return;
			}
		}));
	}

	const wishList = (item: Cases.caseListState) => {
		if (item.wishlisted) {
			dispatch(UI.setWishlistEditPopup({ visible: true, caseno: item.caseno, casetype: item.type }));
		} else {
			dispatch(UI.setWishlistPopup({ visible: true, caseno: item.caseno, casetype: item.type }));
		}
	}

	const calcHeight = (): number => {
		if (!item.selected) {
			return 0;
		}
		return 52;
	}

	return (
		<div className="CaseExpand" style={{ overflow: 'hidden', height: calcHeight() }}>
			<div className="row100" style={{ justifyContent: 'start', alignItems: 'end' }} key={item.caseno} onClick={() => actionOnRow(item)}>
				<div className='buttonPurple' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', overflow: 'hidden', cursor: 'pointer' }} onClick={() => openCase(item)}>
					<div style={{ display: 'flex', alignItems: 'center' }}>
						<img style={{ width: 24, height: 24, marginRight: 8 }} src={icon_mainhub} alt='MainHub-Icon' />
						<div style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>Open Case</div>
					</div>
					<div style={{ width: 32, display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
						{cases.isOpeningCase &&
							<FontAwesomeIcon className='fa-spin' style={{ fontSize: 18, marginRight: 8 }} icon={faSync} />
						}
					</div>
				</div>
				<div className='buttonPurple' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', overflow: 'hidden', cursor: 'pointer' }} onClick={() => openActions(item)}>
					<div style={{ display: 'flex', alignItems: 'center' }}>
						<img style={{ width: 24, height: 24, marginRight: 8 }} src={icon_mainhub} alt='MainHub-Icon' />
						<div style={{ display: 'flex', alignItems: 'center', gap: '10px', whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>Actions
							{item.unviewActions.length > 0 && <div style={{ height: '16px', width: '16px', backgroundColor: 'red', borderRadius: '50%', color: '#FFFFFF', fontSize: '10px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>{item.unviewActions.length}</div>}
						</div>
					</div>
					<div style={{ width: 32, display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
						{cases.isOpeningActions &&
							<FontAwesomeIcon className='fa-spin' style={{ fontSize: 18, marginRight: 8 }} icon={faSync} />
						}
					</div>
				</div>
				<div className='buttonPurple' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', overflow: 'hidden', cursor: 'pointer' }} onClick={() => openHistory(item)}>
					<div style={{ display: 'flex', alignItems: 'center' }}>
						<img style={{ width: 24, height: 24, marginRight: 8 }} src={icon_mainhub} alt='MainHub-Icon' />
						<div style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>Forms & Reports</div>
					</div>
					<div style={{ width: 32, display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
						{cases.isOpeningHistory &&
							<FontAwesomeIcon className='fa-spin' style={{ fontSize: 18, marginRight: 8 }} icon={faSync} />
						}
					</div>
				</div>
				<div className='buttonPurple' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', overflow: 'hidden', cursor: 'pointer' }} onClick={() => openTeam(item)}>
					<div style={{ display: 'flex', alignItems: 'center' }}>
						<img style={{ width: 24, height: 24, marginRight: 8 }} src={icon_team} alt='Team-Icon' />
						<div style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>Meet the Team</div>
					</div>
					<div style={{ width: 32, display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
						{cases.isOpeningTeam &&
							<FontAwesomeIcon className='fa-spin' style={{ fontSize: 18, marginRight: 8 }} icon={faSync} />
						}
					</div>
				</div>
				<div className={(item.wishlisted ? 'buttonGreenRounded' : 'buttonPurple')} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', overflow: 'hidden', cursor: 'pointer' }} onClick={() => wishList(item)}>
					<div style={{ display: 'flex', alignItems: 'center' }}>
						<img style={{ width: 24, height: 24, marginRight: 8 }} src={icon_wishlist} alt='Wishlist-Icon' />
						<div style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>Wishlist</div>
					</div>
					<div style={{ width: 32, display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
						{cases.isWishlisting &&
							<FontAwesomeIcon className='fa-spin' style={{ fontSize: 18, marginRight: 8 }} icon={faSync} />
						}
					</div>
				</div>
			</div>
		</div>
	);
}

export default CaseListExpand;